import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Tabs } from 'antd';
import Wait4Me from '../../../components/Wait4Me';
import BreadCrumb from '../../../components/BreadCrumb';
import RunInstanceResult from './runInstanceResult';
import RunInstanceSummary from './runInstanceSummary';
import style from './index.scss';
import { checkAccess } from '../../common/utils/index';
import { ROUTE_AMLS_SMART_SCREENING } from '../../constants/globalConstants';
import { ALERT_SOURCE_MAPPING } from '../../../util/GlobalConstant';
import { getAttributeByResourceCode } from '../../../util/miscellaneousUtils';

const { TabPane } = Tabs;

const resourceCode = 'APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE';
const alertResourceCode = 'APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS';

export const MatchingRunInstanceConfig = ({
  apiActions,
  settings,
  runInstanceResultListData,
  runInstanceSummaryData,
  authentication,
  widgetItemOperations,
  runInstanceViewExecution
}) => {
  const { navigateTo, configRunInstance, getNSGlobalSettingsPageInfo } =
    apiActions;

  const urlParams = new URLSearchParams(window.location.search);
  const [activeTab, setActiveTab] = useState(urlParams.get('tab'));
  const type = getAttributeByResourceCode(authentication, alertResourceCode);
  const [moduleType, setModuleType] = useState(type ?? ALERT_SOURCE_MAPPING.NS);

  const getPageId = () => {
    switch (moduleType) {
      case '7':
        return 'NS_IAD_ALERTS_LIST';
      case '9':
        return 'TS_IAD_ALERTS_LIST';
      case '16':
        return 'NS_IAD_ALERTS_LIST';
      case '16,17':
        return 'NS_IAD_ALERTS_LIST';
      default:
        return '';
    }
  };

  useEffect(() => {
    if (activeTab === '2') {
      let pageId = getPageId();
      getNSGlobalSettingsPageInfo({ pageId });
    } else getNSGlobalSettingsPageInfo({ pageId: 'NS_IAD_RUN_INSTANCES' });
  }, [activeTab, moduleType]);

  const moduleTypeHandler = (type) => {
    setModuleType(type);
  };

  const routeHandler = (path) => {
    configRunInstance({
      runInstanceConfig: null,
      customerTypeMatchingConfig: null
    });
    navigateTo(path);
  };

  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  const onChangeTabHandler = (selectedTab) => {
    setActiveTab(selectedTab);
    if (selectedTab == 1) {
      routeHandler(`${ROUTE_AMLS_SMART_SCREENING}/runInstance?tab=1`);
    } else {
      routeHandler(`${ROUTE_AMLS_SMART_SCREENING}/runInstance?tab=2`);
    }
  };

  const renderResultTabs = () => {
    if (
      moduleType === ALERT_SOURCE_MAPPING.NS ||
      moduleType === ALERT_SOURCE_MAPPING.PS ||
      moduleType === ALERT_SOURCE_MAPPING.PSRS
    ) {
      return (
        <RunInstanceResult
          settings={settings}
          authentication={authentication}
          moduleType={moduleType}
          moduleTypeHandler={moduleTypeHandler}
          apiActions={apiActions}
          GS={getGSConfig({
            widgetGroupId: 'NS_IAD_ALERTS_LIST_GROUP',
            widgetId: 'NS_IAD_ALERTS_LIST'
          })}
          runInstanceResultList={runInstanceResultListData}
          widgetItemOperations={widgetItemOperations}
        />
      );
    } else {
      return (
        <RunInstanceResult
          settings={settings}
          authentication={authentication}
          moduleType={moduleType}
          moduleTypeHandler={moduleTypeHandler}
          apiActions={apiActions}
          GS={getGSConfig({
            widgetGroupId: 'TS_IAD_ALERTS_LIST_GROUP',
            widgetId: 'TS_IAD_ALERTS_LIST'
          })}
          runInstanceResultList={runInstanceResultListData}
          widgetItemOperations={widgetItemOperations}
        />
      );
    }
  };

  return (
    <Row>
      <Col span={24}>
        <div className={style.run_instance_wrapper}>
          <div className={style.head}>
            <BreadCrumb crumbs={[{ label: 'Run Instance' }]} />
            <div className={style.head_content}>
              <h4>Run Instance</h4>
              {checkAccess(authentication, resourceCode, 'Write') && (
                <button
                  id="matchingRunInstanceConfig-createBtn"
                  onClick={() => {
                    routeHandler(
                      `${ROUTE_AMLS_SMART_SCREENING}/runInstance/create`
                    );
                  }}
                  className={style.btn_primary}>
                  Create
                </button>
              )}
            </div>
          </div>
          <Tabs
            defaultActiveKey={activeTab}
            className={style.tab}
            onChange={onChangeTabHandler}>
            <TabPane tab="Summary" key="1" tabKey="1">
              <RunInstanceSummary
                apiActions={apiActions}
                settings={settings}
                runInstanceSummaryData={runInstanceSummaryData}
                authentication={authentication}
                runInstanceViewExecution={runInstanceViewExecution}
              />
            </TabPane>
            {type !== '17' && (
              <TabPane tab="Result" key="2" tabKey="2">
                {renderResultTabs()}
              </TabPane>
            )}
          </Tabs>
        </div>
      </Col>
    </Row>
  );
};

MatchingRunInstanceConfig.propTypes = {
  apiActions: PropTypes.object,
  settings: PropTypes.object
};

export default MatchingRunInstanceConfig;
